import type { AuthUser } from "@bi/types";

export function homeFor(user: Pick<AuthUser, "role">): string {
  return user.role === "manutencao" ? "/frota/manutencao" : "/";
}

export function canAccessPath(user: Pick<AuthUser, "role" | "isDemo">, pathname: string): boolean {
  let path: string;
  try { path = decodeURIComponent(pathname).replace(/\/$/, "") || "/"; } catch { return false; }
  if (path === "/governanca") return user.role === "admin" && !user.isDemo;
  if (user.role !== "manutencao") return true;
  return path === "/frota/manutencao" || path.startsWith("/frota/manutencao/") || /^\/frota\/memoria\/manutencao\.[^/]+$/.test(path);
}
